module.exports = __webpack_public_path__ + "static/media/LTD.2eda93ee.png";